<div class="ev-a1" [attr.aria-busy]="cargando">
  <output class="ev-a1__estado" *ngIf="cargando && !etapas.length">
    <span class="material-icons" aria-hidden="true">hourglass_top</span>
    Consultando las etapas del proyecto…
  </output>

  <div class="table-page__card" *ngIf="!cargando && error">
    <div class="table-page__empty">
      <span class="material-icons" aria-hidden="true">cloud_off</span>
      <strong>No se pudieron mostrar las etapas</strong>
      <span>{{ error }}</span>
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargar()">
        Volver a intentar
      </button>
    </div>
  </div>

  <div class="ev-a1__rejilla" *ngIf="!error && (etapas.length || !cargando)">
    <!-- Izquierda: las etapas del proyecto, por fecha de inicio (D12). -->
    <section class="ev-a1__panel" aria-labelledby="ev-a1-titulo-etapas">
      <div class="ev-a1__panel-cabeza">
        <div>
          <h2 id="ev-a1-titulo-etapas" class="ev-a1__titulo">Etapas</h2>
          <span class="ev-a1__sub">{{ etapas.length }} {{ etapas.length === 1 ? "etapa registrada" : "etapas registradas" }}</span>
        </div>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="crearEtapa.emit()">
          <span class="material-icons" aria-hidden="true">add_circle_outline</span>
          <span>Crear etapa</span>
        </button>
      </div>

      <p class="ev-a1__vacio" *ngIf="!etapas.length">El proyecto todavía no tiene etapas.</p>

      <ul class="ev-a1__etapas" *ngIf="etapas.length">
        <li *ngFor="let fila of etapas; trackBy: trackEtapa">
          <button type="button" class="ev-a1__etapa" [class.is-on]="fila === seleccionada"
                  [attr.aria-current]="fila === seleccionada ? 'true' : null" (click)="elegir(fila)">
            <span class="ev-a1__etapa-cabeza">
              <span class="ev-a1__etapa-nombre">{{ fila.etapa.nombre || "Sin nombre" }}</span>
              <span class="material-icons ev-a1__flecha" aria-hidden="true">chevron_right</span>
            </span>
            <span class="ev-a1__chips">
              <span *ngFor="let chip of fila.chips" class="table-page__status-badge ev-a1__chip" [ngClass]="chip.clase"
                    [attr.title]="chip.clase === 'is-pending' ? fila.fueraDeFecha : null">
                <span class="material-icons" aria-hidden="true">{{ chip.icono }}</span>{{ chip.texto }}
              </span>
            </span>
            <span class="ev-a1__linea">
              <span class="material-icons" aria-hidden="true">event</span>{{ fila.fechas }}
            </span>
            <span class="ev-a1__linea">
              <span class="material-icons" aria-hidden="true">person</span>Líder: {{ fila.etapa.nombreLider || "Sin líder" }}
            </span>
            <span class="ev-a1__chips">
              <span class="ev-a1__pastilla">{{ fila.versiones }}</span>
              <span class="ev-a1__pastilla is-aviso" *ngIf="fila.abiertas">{{ fila.abiertas }}</span>
            </span>
          </button>
        </li>
      </ul>
    </section>

    <!-- Derecha: la etapa elegida (?etapa=), sus indicadores y sus versiones. -->
    <div class="ev-a1__detalle" *ngIf="seleccionada as fila">
      <section class="ev-a1__card" aria-labelledby="ev-a1-titulo-etapa">
        <div class="ev-a1__card-cabeza">
          <div class="ev-a1__identidad">
            <span class="app-dato-caja__etiqueta">Etapa</span>
            <div class="ev-a1__nombre">
              <h2 id="ev-a1-titulo-etapa">{{ fila.etapa.nombre || "Sin nombre" }}</h2>
              <span *ngFor="let chip of fila.chips" class="table-page__status-badge ev-a1__chip" [ngClass]="chip.clase"
                    [attr.title]="chip.clase === 'is-pending' ? fila.fueraDeFecha : null">
                <span class="material-icons" aria-hidden="true">{{ chip.icono }}</span>{{ chip.texto }}
              </span>
              <span class="ev-a1__sub" *ngIf="fila.detalle">{{ fila.detalle }}</span>
            </div>
            <p class="ev-a1__datos">
              <span><span class="material-icons" aria-hidden="true">event</span>{{ fila.fechas }}</span>
              <span>Líder: <strong>{{ fila.etapa.nombreLider || "Sin líder" }}</strong></span>
              <span>Líder QA: <strong>{{ fila.etapa.nombreLiderQA || "Sin líder QA" }}</strong></span>
            </p>
          </div>
          <div class="ev-a1__acciones">
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="editarEtapa.emit(fila.etapa)">
              <span class="material-icons" aria-hidden="true">edit</span>
              Editar etapa
            </button>
            <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" *ngIf="fila.etapa.puedeCrearVersion"
                    (click)="nuevaVersion()">
              <span class="material-icons" aria-hidden="true">add</span>
              Nueva versión
            </button>
          </div>
        </div>

        <div class="ev-a1__indicadores">
          <div class="app-dato-caja ev-a1__indicador">
            <span class="app-dato-caja__etiqueta">Versiones</span>
            <strong class="app-dato-caja__valor">{{ fila.etapa.indicadores?.versiones ?? versiones.length }}</strong>
            <span class="app-dato-caja__sub" *ngIf="fila.etapa.vigente as vigente; else sinVigente">
              <strong>{{ vigente.nombre || "Sin nombre" }}</strong> vigente
            </span>
            <ng-template #sinVigente><span class="app-dato-caja__sub">Sin versión vigente</span></ng-template>
          </div>
          <div class="app-dato-caja ev-a1__indicador">
            <span class="app-dato-caja__etiqueta">Pruebas ejecutadas</span>
            <strong class="app-dato-caja__valor">{{ fila.etapa.indicadores?.ejecuciones ?? 0 }}</strong>
            <span class="app-dato-caja__sub">{{ textoUltimaEjecucion }}</span>
          </div>
          <div class="app-dato-caja ev-a1__indicador">
            <span class="app-dato-caja__etiqueta">Incidencias</span>
            <strong class="app-dato-caja__valor">{{ fila.etapa.indicadores?.incidencias ?? 0 }}</strong>
            <span class="app-dato-caja__sub">{{ textoIncidencias }}</span>
            <span class="app-dato-caja__sub" *ngIf="sinVersionIdentificada > 0">{{ sinVersionIdentificada }} sin versión identificada</span>
          </div>
          <div class="app-dato-caja ev-a1__indicador">
            <span class="app-dato-caja__etiqueta">Abiertas</span>
            <strong class="app-dato-caja__valor">{{ fila.etapa.indicadores?.abiertas ?? 0 }}</strong>
            <span class="app-dato-caja__sub">{{ textoAbiertas }}</span>
            <span class="ev-a1__barra" aria-hidden="true" *ngIf="porcentajeConVobo !== null">
              <span [style.width.%]="porcentajeConVobo"></span>
            </span>
          </div>
        </div>
      </section>

      <section class="table-page__card" aria-labelledby="ev-a1-titulo-versiones">
        <div class="ev-a1__tabla-cabeza">
          <h3 id="ev-a1-titulo-versiones" class="ev-a1__titulo">
            <span class="material-icons" aria-hidden="true">layers</span>
            Versiones de {{ fila.etapa.nombre || "la etapa" }}
          </h3>
          <span class="ev-a1__contador">
            <span>Total de versiones</span>
            <strong>{{ versiones.length }}</strong>
          </span>
        </div>

        <!-- T3b: las resoluciones que esperan versión se entregan al crear la siguiente versión QA (D3). -->
        <div class="ev-a1__esperan" *ngIf="esperanVersion as esperan">
          <span class="ev-a1__esperan-texto">
            <span class="material-icons" aria-hidden="true">schedule</span>
            <span><strong>{{ esperan }}</strong> · Se entregan al crear la siguiente versión QA</span>
          </span>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  *ngIf="fila.etapa.puedeCrearVersion" (click)="nuevaVersion()">
            <span class="material-icons" aria-hidden="true">add</span>
            Nueva versión
          </button>
        </div>

        <div class="table-page__table-wrap" *ngIf="versiones.length || sinVersionIdentificada > 0; else sinVersiones">
          <table class="table-page__table ev-a1__tabla">
            <caption class="cdk-visually-hidden">Versiones de la etapa {{ fila.etapa.nombre }}</caption>
            <thead>
              <tr>
                <th scope="col">Versión</th>
                <th scope="col">Ambiente</th>
                <th scope="col">Creada</th>
                <th scope="col">Última prueba</th>
                <th scope="col">Detectadas</th>
                <th scope="col">Resueltas aquí</th>
                <th scope="col">Estado</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let version of versiones; trackBy: trackVersion">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name ev-a1__version">{{ version.version.nombre || "Sin nombre" }}</strong>
                    <span class="table-page__subtext">{{ version.version.detalle || "Sin descripción" }}</span>
                  </div>
                </td>
                <td><span class="ev-a1__ambiente">{{ version.version.ambiente || sinDato }}</span></td>
                <td class="ev-a1__fecha">{{ version.creada }}</td>
                <td>
                  <div class="ev-a1__prueba" *ngIf="version.ultima as ultima; else sinPrueba">
                    <span class="ev-a1__prueba-cabeza">
                      <strong>{{ ultima.titulo }}</strong>
                      <span *ngIf="ultima.chip" class="table-page__status-badge ev-a1__chip" [ngClass]="ultima.chip.clase">{{ ultima.chip.texto }}</span>
                    </span>
                    <span class="table-page__subtext" *ngIf="version.lineaPrueba">{{ version.lineaPrueba }}</span>
                    <span class="ev-a1__barra ev-a1__barra--prueba" aria-hidden="true" *ngIf="ultima.porcentaje !== null">
                      <span [style.width.%]="ultima.porcentaje"></span>
                    </span>
                  </div>
                </td>
                <td class="ev-a1__numero">{{ version.version.detectadas }}</td>
                <td class="ev-a1__numero" [class.is-cero]="!version.version.resueltasAqui">{{ version.version.resueltasAqui }}</td>
                <td>
                  <span class="table-page__status-badge ev-a1__chip" [ngClass]="version.chip.clase">
                    <span class="material-icons" aria-hidden="true">{{ version.chip.icono }}</span>{{ version.chip.texto }}
                  </span>
                  <span class="ev-a1__desde" *ngIf="version.desde">{{ version.desde }}</span>
                </td>
                <td class="ev-a1__acciones-fila">
                  <a class="table-page__action-btn" *ngIf="version.ruta" [routerLink]="version.ruta" title="Ver detalle"
                     [attr.aria-label]="'Ver detalle de ' + (version.version.nombre || 'la versión')">
                    <span class="material-icons" aria-hidden="true">visibility</span>
                  </a>
                  <button type="button" class="table-page__action-btn" *ngIf="fila.etapa.puedeRegistrarPruebas && version.version.id"
                          title="Registrar pruebas" [attr.aria-label]="'Registrar pruebas en ' + (version.version.nombre || 'la versión')"
                          (click)="registrarPruebas(version.version)">
                    <span class="material-icons" aria-hidden="true">playlist_add_check</span>
                  </button>
                </td>
              </tr>
              <tr *ngIf="sinVersionIdentificada > 0">
                <td colspan="4">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">Sin versión identificada ({{ sinVersionIdentificada }})</strong>
                    <span class="table-page__subtext">La versión con la que se registraron no existe en la etapa.</span>
                  </div>
                </td>
                <td class="ev-a1__numero">{{ sinVersionIdentificada }}</td>
                <td><span class="ev-a1__sin-dato">{{ sinDato }}</span></td>
                <td><span class="ev-a1__sin-dato">{{ sinDato }}</span></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinPrueba><span class="ev-a1__sin-dato">{{ sinDato }}</span></ng-template>

        <ng-template #sinVersiones>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">layers</span>
            <strong>La etapa todavía no tiene versiones</strong>
            <span *ngIf="fila.etapa.puedeCrearVersion">Crea la primera con «Nueva versión».</span>
          </div>
        </ng-template>

        <div class="table-page__footer ev-a1__pie" [class.is-con-leyenda]="fila.etapa.entregaAutomatica"
             *ngIf="versiones.length || fila.etapa.entregaAutomatica">
          <span class="ev-a1__leyenda" *ngIf="fila.etapa.entregaAutomatica">
            <span class="material-icons" aria-hidden="true">info</span>{{ leyendaEntrega }}
          </span>
          <span *ngIf="versiones.length">Mostrando {{ versiones.length }} de {{ versiones.length }} {{ versiones.length === 1 ? "versión" : "versiones" }}</span>
        </div>
      </section>
    </div>
  </div>
</div>
